<template>
  <div @click="testclick" class="cat-choose" >
    <!-- type：先判断是否有传入显示密码，控制输入框类型是文本/密码，然后是type传入的值 -->
<div class="cat-btn"><span class="cat-span">{{rtest}}</span></div>

    <img v-if="!showicon" src="../assets/down.png"  class="cat-choose__rtest">
      
      <!-- <i
        class="cat-input__icon cat-icon-circle-close"
        v-if="clearable && value"
        @click="clear"
      ></i>
      <i
        class="cat-input__icon cat-icon-view"
        :class="{ 'cat-icon-view-active': passwordVisiable }"
        v-if="showPassword"
        @click="handlepwd"
      ></i> -->
    
  </div>
</template>
 
<script>
export default {
  name: "CatInput",
  props: {
    placeholder: {
      type: String,
      default: "",
    },
      showicon: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    rtest:{
 type: String,
     default: "",
    },
    name: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordVisiable: false, //控制是否显示密码
    };
  },
  methods: {
    testclick(){
this.$emit('codeclick')
    },
    handleinput(event) {
      //父组件在绑定v-model时，其实就绑定的input事件，因此父组件不需要再声明事件了
      this.$emit("input", event.target.value);
    },
    clear() {
      this.$emit("input", "");
    },
    handlepwd() {
      this.passwordVisiable = !this.passwordVisiable;
    },
  },
  computed: {
    //有清空/显示密码，添加类名、显示span
    showSuffix() {
      return this.clearable || this.showPassword;
    },
  },
};
</script>
<style lang='less' scoped>
.cat-choose{
    position: relative;
  
    /* box-sizing: border-box; */
}
.cat-btn{
  border: 1px solid gainsboro; 
  background: white; 
     width: 100%;
    height: 100%;
      border-radius: 8px;
  border: @allboxborder;
  box-sizing: border-box;


}
.cat-span{
   padding: @padingbox;
      box-sizing: border-box;
      color: black;
}
.cat-choose__rtest{
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
}
</style>